import { render } from "./Biorhythm.vue?vue&type=template&id=72c442a3&scoped=true"
import script from "./Biorhythm.vue?vue&type=script&lang=js"
export * from "./Biorhythm.vue?vue&type=script&lang=js"

import "./Biorhythm.vue?vue&type=style&index=0&id=72c442a3&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src310475096/src/AstopiaAdminPanel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c442a3"]])

export default __exports__